import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SocialAuthService } from 'angularx-social-login';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import { getStorage } from '../helper/storage';
import { CURRENT_USER, TOKEN } from '../items/storage-names';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  user: any;
  userSubject: any = new BehaviorSubject<any>(null);

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private socialAuthService: SocialAuthService,
  ) {
    this.user = this.getCurrentUser();
  }

  getCurrentUser() {
    const user = getStorage(CURRENT_USER, true);
    console.log('=== APP SERVICE: getCurrentUser called ===');
    console.log('Retrieved user:', user);
    console.log('is_new_user:', user?.is_new_user);
    console.log('active_subscription:', user?.active_subscription);
    console.log('subscription_status_code:', user?.active_subscription?.subscription_status_code);
    return user;
  }

  setUser(user) {
    this.userSubject.next(this.user = user);
  }

  login(token) {
    localStorage.setItem(TOKEN, token);
    this.router.navigate(['/dashboard']);
  }

  logout(redirect: boolean = true) {
    // this.socialAuthService.signOut(true);
    this.user = null;
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(CURRENT_USER);
    
    // Clear company-related data on logout
    localStorage.removeItem('selectedCompany');
    localStorage.removeItem('userSelectedCompany');
    localStorage.removeItem('is_onelife');

    if (redirect) {
      setTimeout(() => {
        this.router.navigate(['/logout']); 
      }, 1000);
    }
  }

  storeUser(user) {
    console.log('=== APP SERVICE: storeUser called ===');
    console.log('User being stored:', user);
    console.log('is_new_user:', user?.is_new_user);
    console.log('active_subscription:', user?.active_subscription);
    console.log('subscription_status_code:', user?.active_subscription?.subscription_status_code);
    localStorage.setItem(CURRENT_USER, JSON.stringify(user));
  }

  updateUserSubscription(subscription: any) {
    this.user = this.getCurrentUser();
    this.user.active_subscription = subscription;
    this.storeUser(this.user);
    return this.user;
  }

  reload(routerUrl: string) {
    const url = routerUrl;

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(url);
    });

  }
}
